import { render, staticRenderFns } from "./InspectionCostPage.vue?vue&type=template&id=0193f910&scoped=true&"
import script from "./InspectionCostPage.vue?vue&type=script&lang=ts&"
export * from "./InspectionCostPage.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionCostPage.vue?vue&type=style&index=0&id=0193f910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0193f910",
  null
  
)

export default component.exports